import './BlockSideBarSkin.css';
import NewSkin from '../../../images/NewSkin.png';

export const BlockSideBarSkin = () => {
    return (
        <div className="block-side-bar-skin">
            <h2 className="block-side-bar-skin__title">Ежедневный скин</h2>
            <img className="block-side-bar-skin__img" src={NewSkin} alt="новый скин" />
            <button className="block-side-bar-skin__button">
                <span className="block-side-bar-skin__text">Открыть</span>
            </button>
        </div>
    );
};
